var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.$media.importOperation
    ? _c("AppModal", { attrs: { id: _vm.id, options: _vm.options } }, [
        _c(
          "div",
          { staticClass: "flex flex-col items-center justify-center" },
          [
            _c(
              "div",
              { staticClass: "flex justify-center items-center" },
              [
                _c("LoadingCircle", {
                  staticClass: "w-6 h-6 text-primary-700 mr-2"
                }),
                _c("span", [_vm._v("Importing movies...")])
              ],
              1
            ),
            _c(
              "div",
              {
                staticClass:
                  "flex items-center justify-start relative mt-4 bg-primary-200 h-5 w-64 rounded overflow-hidden"
              },
              [
                _c("div", {
                  staticClass: "absolute left-0 inset-y-0 bg-primary-500",
                  style: {
                    width:
                      (100 * _vm.$media.importOperation.current) /
                        _vm.$media.importOperation.total +
                      "%"
                  }
                }),
                _c(
                  "span",
                  {
                    staticClass:
                      "relative ml-2 z-10 tracking-widest\n                font-semibold text-white text-xs"
                  },
                  [
                    _vm._v(
                      " " +
                        _vm._s(_vm.$media.importOperation.current) +
                        "/" +
                        _vm._s(_vm.$media.importOperation.total)
                    )
                  ]
                )
              ]
            ),
            _c(
              "BaseButton",
              {
                staticClass:
                  "border border-primary-500 mt-4 text-sm text-primary-700 justify-center hover:bg-black-overlay",
                on: {
                  click: function($event) {
                    return _vm.$media.cancelImport()
                  }
                }
              },
              [_vm._v(" Stop ")]
            )
          ],
          1
        )
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }